import {STRINGS} from '../../libs/ui/src/index';

import {WS_CLIENT_UPDATED} from '../websocket';
import {
  LOGIN_SUCCESS,
  LOGIN_REQUEST,
  LOGIN_FAILURE,
  SIGNUP_REQUEST,
  SIGNUP_FAILURE,
  UPDATE_CLIENT,
  LOGOUT,
  CLEAR_STATUS,
  GET_CLIENT_SUCCESS,
  GET_CLIENT_FAILURE,
  UPDATE_DATA_CREDITS,
  UPDATE_CLIENT_REQUEST,
  UPDATE_CLIENT_FAILURE,
  UPDATE_CLIENT_SUCCESS,
  UPDATE_CLIENT_SERVER_STATE,
  UPDATE_CLIENT_API_SETUP_STATE,
  SIGNUP_SUCCESS,
  QUESTIONNAIRE_REQUEST,
  QUESTIONNAIRE_SUCCESS,
  QUESTIONNAIRE_SKIP,
  QUESTIONNAIRE_FAILURE,
} from './clientActions';

const initialState: any = {
  status: '',
  loading: false,
  data: undefined,
  team_member: undefined,
  data_step_1: undefined,
  cancelSubscriptionError: '',
  unauthorizedError: false,
  loadingUpdate: false,
  errorUpdate: '',
  serverState: null,
};

export const clientReducers = (state = initialState, action: any) => {
  switch (action.type) {
    case LOGIN_REQUEST: {
      return {...state, loading: true, unauthorizedError: false};
    }
    case LOGIN_SUCCESS: {
      return {...state, status: '', loading: false, data: action.client, team_member: action.team_member};
    }
    case LOGIN_FAILURE: {
      return {...state, loading: false, status: STRINGS.error_login_invalid};
    }
    case SIGNUP_REQUEST: {
      return {...state, loading: true};
    }
    case SIGNUP_FAILURE: {
      return {...state, loading: false, status: action.status};
    }
    case SIGNUP_SUCCESS: {
      return {
        ...state,
        status: '',
        loading: false,
        team_member: action.team_member,
        data_step_1: action.client,
        completed_step_1: true,
      };
    }
    case QUESTIONNAIRE_REQUEST: {
      return {...state, loading: true};
    }
    case QUESTIONNAIRE_SKIP:
    case QUESTIONNAIRE_SUCCESS: {
      return {
        ...state,
        status: '',
        loading: false,
        data: state.data_step_1,
      };
    }
    case QUESTIONNAIRE_FAILURE: {
      return {...state, loading: false, status: action.error};
    }
    case CLEAR_STATUS: {
      return {...state, status: ''};
    }
    case UPDATE_CLIENT: {
      return {...state, data: {...state.data, ...action.client}};
    }
    case UPDATE_CLIENT_REQUEST: {
      return {...state, loadingUpdate: true, errorUpdate: ''};
    }
    case UPDATE_CLIENT_FAILURE: {
      return {...state, loadingUpdate: false, errorUpdate: action.error};
    }
    case UPDATE_CLIENT_SUCCESS: {
      return {...state, loadingUpdate: false, data: {...state.data, ...action.client}};
    }
    case WS_CLIENT_UPDATED: {
      return {...state, data: {...state.data, ...action.client}};
    }
    case GET_CLIENT_SUCCESS: {
      return {...state, data: action.client, team_member: action.team_member};
    }
    case GET_CLIENT_FAILURE: {
      return {...initialState};
    }
    case UPDATE_DATA_CREDITS: {
      const newDataCredits = state.data.data_credits - action.total_matches;
      return {...state, data: {...state.data, data_credits: newDataCredits}};
    }
    case LOGOUT: {
      return {...initialState, unauthorizedError: action.unauthorizedError};
    }
    case UPDATE_CLIENT_SERVER_STATE: {
      return {...state, serverState: action.state};
    }
    case UPDATE_CLIENT_API_SETUP_STATE: {
      return {...state, data: {...state.data, has_api_setup: action.state}};
    }

    default:
      return state;
  }
};
